<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carinouttemp_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/car/carinouttemp';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '主键',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出入标识',
            prop: 'ioSign',
            rules: [
              {
                required: true,
                message: '请输入出入标识',
                trigger: 'change',
              },
            ],
          },
          {
            label: '汽车分组代码',
            prop: 'group',
            rules: [
              {
                required: true,
                message: '请输入汽车分组代码',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车主姓名',
            prop: 'carOwner',
            rules: [
              {
                required: true,
                message: '请输入车主姓名',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车组',
            prop: 'carGroup',
            rules: [
              {
                required: true,
                message: '请输入车组',
                trigger: 'change',
              },
            ],
          },
          {
            label: '外部来源车类型编号',
            prop: 'carTypeNo',
            rules: [
              {
                required: true,
                message: '请输入外部来源车类型编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车类型',
            prop: 'carType',
            rules: [
              {
                required: true,
                message: '请输入车类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场车牌号',
            prop: 'inCarNo',
            rules: [
              {
                required: true,
                message: '请输入入场车牌号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场通道名称',
            prop: 'inDeviceName',
            rules: [
              {
                required: true,
                message: '请输入入场通道名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场通道标识',
            prop: 'inFlag',
            rules: [
              {
                required: true,
                message: '请输入入场通道标识',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场时间',
            prop: 'inTime',
            rules: [
              {
                required: true,
                message: '请输入入场时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场图片',
            prop: 'inPic',
            rules: [
              {
                required: true,
                message: '请输入入场图片',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场操作名称',
            prop: 'inOperationName',
            rules: [
              {
                required: true,
                message: '请输入入场操作名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场操作时间',
            prop: 'inOperationTime',
            rules: [
              {
                required: true,
                message: '请输入入场操作时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场操作类型名称',
            prop: 'inOperationTypeName',
            rules: [
              {
                required: true,
                message: '请输入入场操作类型名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场车牌号',
            prop: 'outCarNo',
            rules: [
              {
                required: true,
                message: '请输入出场车牌号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场通道名称',
            prop: 'outDeviceName',
            rules: [
              {
                required: true,
                message: '请输入出场通道名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场通道',
            prop: 'outFlag',
            rules: [
              {
                required: true,
                message: '请输入出场通道',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场时间',
            prop: 'outTime',
            rules: [
              {
                required: true,
                message: '请输入出场时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场图片',
            prop: 'outPic',
            rules: [
              {
                required: true,
                message: '请输入出场图片',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场操作名称',
            prop: 'outOperationName',
            rules: [
              {
                required: true,
                message: '请输入出场操作名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场操作时间',
            prop: 'outOperationTime',
            rules: [
              {
                required: true,
                message: '请输入出场操作时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场操作类型名称',
            prop: 'outOperationTypeName',
            rules: [
              {
                required: true,
                message: '请输入出场操作类型名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付方式',
            prop: 'payType',
            rules: [
              {
                required: true,
                message: '请输入支付方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收款单主键',
            prop: 'payId',
            rules: [
              {
                required: true,
                message: '请输入收款单主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '总金额',
            prop: 'totalMoney',
            rules: [
              {
                required: true,
                message: '请输入总金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应缴费用',
            prop: 'payableMoney',
            rules: [
              {
                required: true,
                message: '请输入应缴费用',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费金额',
            prop: 'chargeMoney',
            rules: [
              {
                required: true,
                message: '请输入收费金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场备注',
            prop: 'inMemo',
            rules: [
              {
                required: true,
                message: '请输入入场备注',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场备注',
            prop: 'outMemo',
            rules: [
              {
                required: true,
                message: '请输入出场备注',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'in_pic_min_',
            prop: 'inPicMin',
            rules: [
              {
                required: true,
                message: '请输入in_pic_min_',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'out_pic_min_',
            prop: 'outPicMin',
            rules: [
              {
                required: true,
                message: '请输入out_pic_min_',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场车辆颜色',
            prop: 'outCarNoColor',
            rules: [
              {
                required: true,
                message: '请输入出场车辆颜色',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场车辆颜色',
            prop: 'inCarNoColor',
            rules: [
              {
                required: true,
                message: '请输入入场车辆颜色',
                trigger: 'change',
              },
            ],
          },
          {
            label: '下次免费时间',
            prop: 'nextFreeTime',
            rules: [
              {
                required: true,
                message: '请输入下次免费时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区id',
            prop: 'areaId',
            rules: [
              {
                required: true,
                message: '请输入小区id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '新的入场时间',
            prop: 'newInTime',
            rules: [
              {
                required: true,
                message: '请输入新的入场时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '停车区域：a、b、c',
            prop: 'zone',
            rules: [
              {
                required: true,
                message: '请输入停车区域：a、b、c',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否补缴 0.否 1.是',
            prop: 'handinFlag',
            rules: [
              {
                required: true,
                message: '请输入是否补缴 0.否 1.是',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否补缴 0.否 1.是',
            prop: 'createEmp',
            rules: [
              {
                required: true,
                message: '请输入是否补缴 0.否 1.是',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carinouttemp_add, false),
        viewBtn: this.vaildData(this.permission.carinouttemp_view, false),
        delBtn: this.vaildData(this.permission.carinouttemp_delete, false),
        editBtn: this.vaildData(this.permission.carinouttemp_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
